<template>
  <section class="bg-gray-50 py-8 md:py-16" data-aos="fade-up">
    <div class="px-4 mx-auto">
      <h3
        class="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-6 md:mb-8 text-center"
      >
        Our Distinguished Members
      </h3>

      <div class="overflow-hidden">
        <!-- First Row - Left to Right -->
        <div class="flex animate-scroll-left py-2 md:py-4">
          <div
            v-for="member in firstHalf"
            :key="member.full_name"
            class="flex-none mx-2 md:mx-4 w-56 md:w-72 bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            <div class="p-4 md:p-6">
              <div
                class="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-full flex items-center justify-center mb-3 md:mb-4"
              >
                <span class="text-lg md:text-xl text-white font-semibold">
                  {{ member.full_name.charAt(0) }}
                </span>
              </div>
              <h4
                class="text-base md:text-lg font-semibold text-gray-900 dark:text-white mb-1 md:mb-2 line-clamp-1"
              >
                {{ member.full_name }}
              </h4>
              <p
                class="text-xs md:text-sm text-gray-600 dark:text-gray-300 line-clamp-2"
              >
                {{ member.institution }}
              </p>
            </div>
          </div>
        </div>

        <!-- Second Row - Right to Left -->
        <div class="flex animate-scroll-right py-2 md:py-4">
          <div
            v-for="member in secondHalf"
            :key="member.full_name"
            class="flex-none mx-2 md:mx-4 w-56 md:w-72 bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            <div class="p-4 md:p-6">
              <div
                class="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-full flex items-center justify-center mb-3 md:mb-4"
              >
                <span class="text-lg md:text-xl text-white font-semibold">
                  {{ member.full_name.charAt(0) }}
                </span>
              </div>
              <h4
                class="text-base md:text-lg font-semibold text-gray-900 dark:text-white mb-1 md:mb-2 line-clamp-1"
              >
                {{ member.full_name }}
              </h4>
              <p
                class="text-xs md:text-sm text-gray-600 dark:text-gray-300 line-clamp-2"
              >
                {{ member.institution }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showBrowseButton" class="text-center mt-8 md:mt-12">
      <UButton to="/people?utm_source=cardHome" text="View All Members">
      </UButton>
    </div>
  </section>
</template>

<script setup>
defineProps({
  showBrowseButton: {
    type: Boolean,
    default: true,
  },
});

let members = [
  {
    full_name: "Dr Manjunath N M",
    institution: "PMNM dental college Bagalkot",
  },
  {
    full_name: "Dr. Poonam Goel",
    institution: "NMC Speciality Hospital, Abu Dhabi, UAE",
  },
  {
    full_name: "Dr. Gopinath thilak p. S",
    institution: "Absmids",
  },
  {
    full_name: "Dr Priyadarshini Kaushik",
    institution:
      "Studied from RGUHS. Karnataka. Working at R R Dental college Udaipur",
  },
  {
    full_name: "Ankita Chugh",
    institution: "AIIMS Jodhpur",
  },
  {
    full_name: "Dr. Devi Arul",
    institution: "Sri Ramachandra Dental College & Hospital",
  },
  {
    full_name: "Dr. Charu Dixit",
    institution:
      "People's College of Dental Sciences and Research Centre, Bhopal",
  },
  {
    full_name: "Nishhaa Shetty",
    institution: "Facial aesthetics center",
  },
  {
    full_name: "Dr. Kamaldeep Kaur",
    institution: "D.Y. Patil University, Navi Mumbai",
  },
  {
    full_name: "Sarabpreet Singh",
    institution: "VIT University",
  },
  {
    full_name: "Dr Harshhan D",
    institution: "Sri Ramachandra Institute of Higher Education and Research",
  },
  {
    full_name: "Dr Niveditha N",
    institution: "Vokkalighara Sangha Dental College and Hospital",
  },
  {
    full_name: "Dr Santosh A Nandimath",
    institution: "V S Dental College & Hosp",
  },
  {
    full_name: "Dr.Sachin Gawahale",
    institution: "SRM University",
  },
  {
    full_name: "Dr. Shivani Vanam",
    institution: "Kamineni Institute of Dental Sciences",
  },
  {
    full_name: "Dr. Auswaf Ahsan",
    institution: "IQRAA Hospital",
  },
  {
    full_name: "Dr. Meenakshi Bhasin",
    institution: "Hitkarini Dental College and Hospital, Jabalpur",
  },
  {
    full_name: "Anunay Kumar",
    institution: "Kholan University",
  },
  {
    full_name: "Dr. Ashir KR",
    institution: "KMCT Dental college",
  },
  {
    full_name: "Dr. Abhay Suresh Kulkarni",
    institution: "PDU Dental College SDCH Pune",
  },
  {
    full_name: "Anlin Anto",
    institution: "Face 360",
  },
  {
    full_name: "Dr. Diksha Singhal",
    institution: "Peoples University Bhopal",
  },
  {
    full_name: "Dr. Basavaraj Bhagawati",
    institution: "Dashmesh Institute of Research and Dental Sciences Faridkot",
  },
];

// Split members into two halves for different directions
const firstHalf = computed(() =>
  members.slice(0, Math.ceil(members.length / 2))
);
const secondHalf = computed(() => members.slice(Math.ceil(members.length / 2)));
</script>

<style>
.animate-scroll-left {
  animation: scroll-left 30s linear infinite;
}

.animate-scroll-right {
  animation: scroll-right 30s linear infinite;
}

@media (min-width: 768px) {
  .animate-scroll-left {
    animation-duration: 60s;
  }
  .animate-scroll-right {
    animation-duration: 60s;
  }
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes scroll-right {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
}

.animate-scroll-left:hover,
.animate-scroll-right:hover {
  animation-play-state: paused;
}
</style>
